<template>
    <b-form-group
        :label="inputLabel"
        :label-for="inputId"
        class="required-field"
    >
        <b-form-file
            :id="inputId"
            :name="inputName"
            v-bind="$attrs"
            :disabled="loading || disabled"
            @input="encrypt"
        ></b-form-file>
    </b-form-group>
</template>

<script>
import { mapGetters } from 'vuex'
import request from '@/utils/request'
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {}, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        inputId: {
            type: String,
        },
        inputName: {
            type: String,
        },
        inputLabel: {
            type: String,
        },
        fileType: {
            type: String,
        },
        disabled: {
            type: Boolean,
        },
        value: {
            type: String,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {}
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading']),
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        encrypt(input) {
            var file = input
            var reader = new FileReader()
            reader.onload = () => {
                var key = process.env.VUE_APP_CRYPTO_SECERT_KEY
                var wordArray = this.CryptoJS.lib.WordArray.create(
                    reader.result
                ) // Convert: ArrayBuffer -> WordArray
                var encrypted = this.CryptoJS.AES.encrypt(
                    wordArray,
                    key
                ).toString() // Encryption: I: WordArray -> O: -> Base64 encoded string (OpenSSL-format)

                var fileEnc = new Blob([encrypted]) // Create blob from string
                var filename = file.name + '.enc'
                const myFile = new File([fileEnc], filename, {
                    type: fileEnc.type,
                })

                this.onFileInput(myFile)
            }
            reader.readAsArrayBuffer(file)
        },
        /**
         * Handle when the user selects a file
         *
         * @return {void}
         */
        async onFileInput(file) {
            if (file) {
                // this.encrypt(file)
                this.$store.commit('setLoading', true)
                try {
                    const formData = new FormData()

                    formData.append('type', this.fileType)
                    formData.append('file', file)

                    const headers = {
                        'Content-Type': 'multipart/form-data',
                    }

                    const { data } = await request.post('files/', formData, {
                        headers,
                    })

                    this.$emit('input', data.data.fileName)
                    this.$emit('update:originalFileName', file.name)
                } catch (error) {
                    this.$store.commit('setError', error)
                }
                this.$store.commit('setLoading', false)
            }
        }, // End of onFileInput() method
    }, // End of Component > mounted
} // End of export default
</script>
